const getCartId = (cart) => {
  if (cart && cart.context) {
    const state = cart.context.isAnonymous ? "anonymous" : "non-anonymous";
    return cart.context.userId + "-" + cart.context.retailId + "-" + state;
  }
  return null;
};

const createCookie = (key, value, domain = "", exp = 30) => {
  const date = new Date();
  date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
  const expires = `;expires=${date.toUTCString()}`;
  const _domain = domain ? `;domain=${domain}` : "";
  document.cookie = `${key}=${value}${expires}${_domain};path=/`;
};

const readCookie = (cookieKey) => {
  const nameEQ = cookieKey + "=";
  const ca = document.cookie.split(";");
  for (let i = 0, max = ca.length; i < max; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
};
/*
    Fetches quantity from event payload instead of API response,
    in order to support both INGKA and NON-INGKA markets
*/
const updateHeaderBadge = (items) => {
  const countryCode = CONFIG.countryCode;
  const getCartCount = Number(readCookie(`IRMW_CART_COUNT_${countryCode}`));
  const quantity =
    getCartCount + items.reduce((acc, item) => acc + Number(item.quantity), 0) || 0;
  const domain = window.location.host.includes("ikeadt.com")
    ? ".ikeadt.com"
    : ".ikea.com";
  createCookie(`IRMW_CART_COUNT_${countryCode}`, String(quantity), domain);
  const event = document.createEvent("Event");
  event.initEvent("addtocart", true, true);
  document.body.dispatchEvent(event);
};

module.exports = {
  getCartId,
  updateHeaderBadge,
};
